import $ from 'jquery';
require('./shared/layout');

// affix scroll
(function () {
  var afxContainer = $('#affix_container');
  var navbarHeight = $('#navbar').height() - 20;

  var checkAffixStick = function () {
    if ($(this).scrollTop() > navbarHeight) {
      afxContainer.addClass('affixed');
      $('.affix_wrap').css({
        transform: 'translate(calc(' + afxContainer.width() + 'px - 300px), 0)',
      });
    } else {
      afxContainer.removeClass('affixed');
      $('.affix_wrap').css({ transform: 'none' });
    }
  };

  var checkAffixHeight = function () {
    var footerTop = $('.footer-section').offset().top;
    var afxWrap = $('.affix_wrap');
    var viewLeft = footerTop - this.scrollY;
    if (viewLeft <= this.innerHeight) {
      var h = viewLeft - afxWrap[0].offsetTop - 40;
      afxWrap.css({ height: h });
    } else {
      // calc(100% - 60px)
      afxWrap.css({ height: 'auto' });
    }
  };

  window.addEventListener('scroll', function (e) {
    checkAffixStick.call(this, e);
    checkAffixHeight.call(this, e);
  });
  // run init
  setTimeout(checkAffixStick, 0);
})();
